/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CustomerNumberItemRequestBuilderNavigationMetadata, CustomerNumberItemRequestBuilderRequestsMetadata, type CustomerNumberItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites
 */
export interface FavoritesRequestBuilder extends BaseRequestBuilder<FavoritesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.favorites.item collection
     * @param customerNumberId The customer whose lists are being read.
     * @returns {CustomerNumberItemRequestBuilder}
     */
     byCustomerNumberId(customerNumberId: string) : CustomerNumberItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const FavoritesRequestBuilderUriTemplate = "{+baseurl}/api/favorites";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FavoritesRequestBuilderNavigationMetadata: Record<Exclude<keyof FavoritesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNumberId: {
        requestsMetadata: CustomerNumberItemRequestBuilderRequestsMetadata,
        navigationMetadata: CustomerNumberItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["customerNumber%2Did"],
    },
};
/* tslint:enable */
/* eslint-enable */
